import { useAtomValue } from 'jotai';
import callApi from 'lib/callApi';
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { companyIdAtom } from 'views/state';

export type PolicyValueType = 'all' | number;

interface PolicyFilterDropdownProps {
  selectedPolicyId: PolicyValueType;
  for_hosts?: number[];
  onChange: (selectedId: PolicyValueType) => void;
}

interface Policy {
  id: number;
  display_name: string;
}

const PolicyFilterDropdown: React.FC<PolicyFilterDropdownProps> = ({
  selectedPolicyId,
  for_hosts,
  onChange,
}) => {
  const companyId = useAtomValue(companyIdAtom);
  const [policyData, setPolicyData] = useState<Policy[]>([]);

  useEffect(() => {
    const fetchPolicies = async () => {
      try {
        if (companyId && companyId !== -1) {
          const params = {
            company_id: companyId,
          };

          if (Array.isArray(for_hosts) && for_hosts.length > 0) {
            params['for_hosts'] = for_hosts.join(',');
          }

          const responseData = await callApi('pcm/policies/', 'GET', params);
          setPolicyData(responseData?.data);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchPolicies();
  }, [companyId, for_hosts]);

  const policyFilterOptions = [
    { value: 'all', label: 'All Policies' },
    ...policyData?.map((policy) => ({
      value: policy.id,
      label: policy.display_name,
    })),
  ];

  return (
    <Select
      id="PolicyFilterDropdown"
      className="custom-360-dropdown"
      value={policyFilterOptions.find((x) => x.value === selectedPolicyId)}
      onChange={(e) => {
        if (e) {
          onChange(e.value as PolicyValueType);
        }
      }}
      options={policyFilterOptions}
      placeholder="Select Policy"
    />
  );
};

export default PolicyFilterDropdown;
